import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { scrollToId, scrollToTop } from "@/lib/scroll";

const LINKS = [
    { id: "features", label: "Features" },
    { id: "how-it-works", label: "How it works" },
    { id: "about", label: "About" },
    { id: "faqs", label: "FAQs" },
    { id: "contact", label: "Contact" },
];

export default function Footer() {
    return (
        <footer className="border-t border-white/10">
            <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8 lg:px-12 lg:py-16">
                <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
                    <div>
                        <button
                            data-testid="footer-brand-logo"
                            onClick={scrollToTop}
                            className="font-display text-3xl font-extrabold lowercase tracking-tight text-fynary-lime"
                        >
                            fynary.
                        </button>
                        <p className="mt-3 max-w-xs text-sm leading-relaxed text-fynary-muted">Your money, explained.</p>
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                data-testid="footer-instagram-link"
                                href="https://www.instagram.com/fynary.in/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="fynary on Instagram"
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-fynary-surface text-fynary-muted transition-[color,border-color] duration-200 hover:border-fynary-lime/40 hover:text-fynary-lime"
                            >
                                <Instagram className="h-4 w-4" />
                            </a>
                            <a
                                data-testid="footer-email-link"
                                href="mailto:workfynary@gmail.com"
                                aria-label="Email fynary"
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-fynary-surface text-fynary-muted transition-[color,border-color] duration-200 hover:border-fynary-lime/40 hover:text-fynary-lime"
                            >
                                <Mail className="h-4 w-4" />
                            </a>
                        </div>
                    </div>

                    <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-fynary-muted">Explore</p>
                            <ul className="mt-4 space-y-2.5">
                                {LINKS.map((l) => (
                                    <li key={l.id}>
                                        <button
                                            data-testid={`footer-link-${l.id}`}
                                            onClick={() => scrollToId(l.id)}
                                            className="text-sm text-white/80 transition-[color] duration-200 hover:text-fynary-lime"
                                        >
                                            {l.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-fynary-muted">Legal</p>
                            <ul className="mt-4 space-y-2.5">
                                <li>
                                    <Link
                                        data-testid="footer-privacy-link"
                                        to="/privacy"
                                        className="text-sm text-white/80 transition-[color] duration-200 hover:text-fynary-lime"
                                    >
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        data-testid="footer-terms-link"
                                        to="/terms"
                                        className="text-sm text-white/80 transition-[color] duration-200 hover:text-fynary-lime"
                                    >
                                        Terms of Use
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row sm:items-center">
                    <p className="text-xs text-fynary-muted">© 2026 fynary. All rights reserved.</p>
                    <p className="text-xs text-fynary-muted">Made for people who wonder where their money went.</p>
                </div>
            </div>
        </footer>
    );
}
